import { render, staticRenderFns } from "./TableColumnFormat.md?vue&type=template&id=05ffd6e2"
import script from "./TableColumnFormat.md?vue&type=script&lang=js"
export * from "./TableColumnFormat.md?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports